<div class="MessageModal">
    <mat-toolbar>
        <h3>{{ "role.existing.user.message1" | translate }}</h3>
    </mat-toolbar>
        <mat-dialog-content><br/>
            <span  class="mt-25"></span><br/>
            <span>{{ "role.existing.user.message2" | translate : { NUMBER_OF_USERS: user_count } }}</span><br/>
            <form class="form-signin p-[15px] flex flex-row flex-wrap justify-between items-start" [formGroup]="form">
                <div class="w-[98%] lt-md:w-full">
                    <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>{{ "role" | translate }}</mat-label>
                    <mat-select required class="form-control" formControlName="usrRoles" multiple>
                        <mat-option [value]="role.roleID" *ngFor="let role of role_list">
                            {{ role.roleNameEn.charAt(0).toUpperCase() + role.roleNameEn.slice(1) }}
                        </mat-option>
                    </mat-select>
                    <mat-icon matSuffix>group</mat-icon>
                    </mat-form-field>
                    <ng-container *ngIf="form.controls['usrRoles'].invalid">
                    <mat-error *ngIf="form.controls['usrRoles'].errors.required">
                        {{ "required" | translate }}
                    </mat-error>
                    </ng-container>
                </div>
                <div class="submit_button w-[98%] lt-md:w-full" >
                    <button mat-raised-button color="primary" type="button" (click)="onSubmit()" [disabled]="isValid(form)"
                      mat-dialog-close>
                      {{ "role.assign" | translate }}
                    </button>
                  </div>
            </form>
        </mat-dialog-content>
        
        <mat-dialog-actions style="float:right">
            <button mat-dialog-close mat-button mat-raised-button color="accent">{{ "close" | translate }}</button>
        </mat-dialog-actions>
  </div>